import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import FallBack from "./components/FallBack";
import { HelmetProvider } from "react-helmet-async";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <HelmetProvider>
        <FallBack>
          <App />
        </FallBack>
      </HelmetProvider>
    </React.StrictMode>
  </BrowserRouter>
);
